export default "__VITE_ASSET__KaxjJ27f__"